import React from 'react';
import { Layers, Globe, Anchor } from 'lucide-react';
export function ModelIndependence() {
  return <section className="py-24 px-6 md:px-12 lg:px-24 bg-[#F8F8F8]" data-id="element-891">
      <div className="max-w-7xl mx-auto" data-id="element-892">
        <div className="text-center mb-16" data-id="element-893">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 font-['Syne']" data-id="element-894">
            Model Independence
          </h2>
          <p className="text-xl text-gray-600 font-light max-w-3xl mx-auto" data-id="element-895">
            Frontier models and agentic frameworks are
            utilities. If your AI transformation relies on ungoverned
            prompts, you create <strong data-id="element-896">Prompt Debt</strong>.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-897">
          <div className="bg-white p-8 rounded border border-gray-200" data-id="element-898">
            <Layers className="w-8 h-8 text-[#0066FF] mb-4" data-id="element-899" />
            <h3 className="text-xl font-bold mb-3 font-['Syne']" data-id="element-900">
              Abstracted IP
            </h3>
            <p className="text-gray-600" data-id="element-901">
              Synthia treats your reasoning as an independent architectural
              layer. Your IP lives above the model layer.
            </p>
          </div>

          <div className="bg-white p-8 rounded border border-gray-200" data-id="element-902">
            <Globe className="w-8 h-8 text-[#0066FF] mb-4" data-id="element-903" />
            <h3 className="text-xl font-bold mb-3 font-['Syne']" data-id="element-904">
              Universal Translation
            </h3>
            <p className="text-gray-600" data-id="element-905">
              Our Instruction Layer dynamically formats your rules for OpenAI,
              Anthropic, Gemini, or any future provider.
            </p>
          </div>

          <div className="bg-white p-8 rounded border border-gray-200" data-id="element-906">
            <Anchor className="w-8 h-8 text-[#0066FF] mb-4" data-id="element-907" />
            <h3 className="text-xl font-bold mb-3 font-['Syne']" data-id="element-908">
              Future-Proofing
            </h3>
            <p className="text-gray-600" data-id="element-909">
              When models update or "drift," your intelligence library remains
              the constant anchor of your operations.
            </p>
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-910">
          <p className="text-2xl font-bold font-['Syne']" data-id="element-911">
            You own the logic.{' '}
            <span className="text-gray-400" data-id="element-912">They own the compute.</span>
          </p>
        </div>
      </div>
    </section>;
}